import type { UiIconNames } from "@icg360/design-system";

/**
 * Maps policy type codes to their icon name
 */
const policyTypeIconMap: { [key: string]: UiIconNames } = {
  HO6: "MixedUse",
  FLD: "Flood",
};

/**
 * Gets the icon name to display for a policy
 * @param policy - isCommercial flag and policy type code (e.g., "HO6", "FLD") for the policy
 * @returns The icon name to use, defaulting to "Home" for residential policies without a more specific match
 */
export const getPolicyIconName = (policy: {
  isCommercial?: boolean | null;
  policyType?: string | null;
}): UiIconNames => {
  if (policy.isCommercial) return "Store";
  return (policy.policyType && policyTypeIconMap[policy.policyType]) || "Home";
};
